
import { computed, defineComponent, PropType } from 'vue'

import MessageFile from './MessageFile.vue'

import { OktellWhatsappMappedMessage } from '@/core/types/oktell.types';

export default defineComponent({
    components: {
        MessageFile,
    },
    props: {
        message: {
            type: Object as PropType<OktellWhatsappMappedMessage>,
            default: null
        }
    },
    setup(props) {
        const padZero = (num: number | string) => {
            return (Number(num) < 10 ? '0' : '') + num
        }

        const formatTimestampToTime = (message: OktellWhatsappMappedMessage | null) => {
            if (message && message.data && message.data.time) {
                const timestamp = message.data.time

                const date = new Date(timestamp * 1000)
                const day = date.getDate()
                const month = date.getMonth() + 1
                const year = date.getFullYear()

                const hours = date.getHours()
                const minutes = date.getMinutes()

                return `${padZero(day)}.${padZero(month)}.${year} ${padZero(hours)}:${padZero(
                    minutes
                )}`
            }

            return null
        }

        const messageFile = computed(() => {
            if (props.message && props.message.data && props.message.data.message) {
                return props.message.data.message.file
            }

            return null
        })

        const isManager = computed(() => {
            if (props.message && props.message.data) {
                return props.message.data.fromMe
            }

            return false
        })

        const messageAuthor = computed(() => {
            if (isManager.value) return null

            if (props.message && props.message.data && props.message.data.fromUser) {
                return props.message.data.fromUser.name
            }

            if (props.message.phone) {
                return props.message.phone
            }

            return 'Неизвестный автор'
        })

        const messageText = computed(() => {
            if (props.message) {
                if (props.message.message) {
                    return props.message.message
                }

                if (props.message.data && props.message.data.message) {
                    if (props.message.data.message.text) {
                        return props.message.data.message.text
                    }

                    if (props.message.data.message.caption) {
                        return props.message.data.message.caption
                    }
                }
            }
        })

        return {
            formatTimestampToTime,
            isManager,
            messageFile,
            messageAuthor,
            messageText
        }
    },
})
